module.exports = __webpack_public_path__ + "static/5-7c06daf5f0c850b956b970d669b682ab.png";